import { useContext, useEffect, useState } from 'react';
import ServerContext from '../../../contexts/serverContext';

const ENABLE_ONBOARDING_VEHICLE_SELECTOR = {
    dev: true,
    qa: true,
    prod: true,
    local: true,
    uat: true,
}[process.env.REACT_APP_ACTIVE_PROFILE || 'local'];

export const useVehicleSelectorToggle = () => {
    const { brand, currentLanguageRegionCode } = useContext(ServerContext);
    const [shouldShowVehicleSelector, setShouldShow] = useState(true);

    useEffect(() => {
        if (
            currentLanguageRegionCode != 'en-us' ||
            (brand === 'lincoln' &&
                process.env.REACT_APP_ACTIVE_PROFILE === 'prod')
        ) {
            return setShouldShow(false);
        } else setShouldShow(ENABLE_ONBOARDING_VEHICLE_SELECTOR as boolean);
    }, [currentLanguageRegionCode]);

    return shouldShowVehicleSelector;
};
